import { ArrowRightIcon, ClosePopupIconV2, QuestionIcon } from "@share/icons";
import { Button, Popover } from "antd-mobile";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ProductSettingTour from "./ProductSettingTour";
import { AFFILIATE_SETTING_TOUR_CLASS_NAME } from "./ProductSettingTour/setting-tour-config";
import { useAppDispatch, useAppSelector } from "@app/hooks";
import { setDynamicParams } from "@features/main/store/dynamicSlice";

const AffiliateProductTourOpening = ({}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const dynamicConfig = useAppSelector((state) => state.dynamicConfig);
  const [isOpenProductSettingTour, setIsOpenProductSettingTour] =
    useState(false);
  const popoverRef = useRef(null);
  const popoverManualRef = useRef(null);

  const handleHidePopoverManual = () => {
    popoverManualRef.current.hide();
  };

  useEffect(() => {
    dispatch(
      setDynamicParams({
        data: { isOpenAffiliateSettingTour: isOpenProductSettingTour },
      })
    );
    const timer = setTimeout(() => {
      const settingTourOverlay = document.getElementsByClassName(
        "introjs-overlay"
      )[0] as any;
      const blockEditorWrapper = document.querySelector(
        ".block-editor-wrapper"
      ) as any;
      if (isOpenProductSettingTour) {
        settingTourOverlay.style.display = "none";
      } else {
        settingTourOverlay?.remove();
      }
      if (isOpenProductSettingTour) {
        if (blockEditorWrapper)
          blockEditorWrapper.style.cssText = "pointer-events: none;";
      } else {
        if (blockEditorWrapper) blockEditorWrapper.style.cssText = "";
      }
    }, 100);
    () => clearTimeout(timer);
  }, [isOpenProductSettingTour]);

  const handleHideSettingTour = () => {
    setIsOpenProductSettingTour(false);
  };

  const contentPopoverManual = () => {
    return (
      <div className="w-[270px] relative max-w-full">
        <div
          className="w-[32px] h-[32px] absolute p-1 right-2 top-2 cursor-pointer z-[3]"
          onClick={() => handleHidePopoverManual()}
        >
          <ClosePopupIconV2 fillColor="#fff" />
        </div>
        <div className="">
          <img
            src="https://image.passio.eco/page-builder/page-builder/affiliate-setting-tour/affiliate-setting-tour-opening.gif"
            alt=""
          />
        </div>
        <div className="p-3">
          <div className="mb-2 text-lg leading-[25px] font-bold">
            {t("ss_builder_affiliate_setting_popover_manual_title")}
          </div>
          <div className="text-[15px] font-normal leading-[140%] text-textColorDefault  mb-5">
            {t("ss_builder_affiliate_setting_popover_manual_content")}
          </div>
          <Button
            color="primary"
            size="middle"
            fill="solid"
            onClick={() => {
              handleHidePopoverManual();
              setIsOpenProductSettingTour(true);
            }}
            block
          >
            <span className="flex items-center w-full justify-center gap-2 text-[17px]">
              {t("ss_builder_popover_manual_button")}{" "}
              <ArrowRightIcon fillColor="#fff" />
            </span>
          </Button>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className="user-manual"
        ref={popoverRef}
      >
        <Popover
          className="popover-user-manual"
          content={contentPopoverManual()}
          placement="bottom-end"
          // visible={isOpenPopoverManual}
          trigger="click"
          stopPropagation={["click"]}
          getContainer={() => popoverRef.current}
          ref={popoverManualRef}
        >
          <span className={AFFILIATE_SETTING_TOUR_CLASS_NAME.STEP_9}>
            <QuestionIcon
              width={20}
              height={20}
              className="cursor-pointer"
            />
          </span>
        </Popover>
      </div>
      {isOpenProductSettingTour && (
        <ProductSettingTour handleHideSettingTour={handleHideSettingTour} />
      )}
    </>
  );
};

export default AffiliateProductTourOpening;
